import { useState } from "react";
import { REGLAS_PASSWORD } from "../../constants/password";
import "./CampoPassword.css";

const IconoOjo = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const IconoOjoTachado = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10.6 5.1A10.8 10.8 0 0 1 12 5c6.5 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4.2" />
    <path d="M6.6 6.6A17.4 17.4 0 0 0 2 12s3.5 7 10 7a10.6 10.6 0 0 0 5.4-1.5" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    <path d="M2 2l20 20" />
  </svg>
);

/**
 * Campo de contraseña con botón para mostrar/ocultar.
 * - mostrarReglas: muestra debajo las reglas (8 caracteres, un número) y si ya se cumplen.
 */
export default function CampoPassword({
  id, value, onChange, placeholder = "", autoComplete = "new-password",
  autoFocus = false, mostrarReglas = false, invalido = false,
}) {
  const [visible, setVisible] = useState(false);
  const idReglas = mostrarReglas && id ? `${id}-reglas` : undefined;

  return (
    <div className="campo-password">
      <div className="cp-envoltura">
        <input
          id={id}
          type={visible ? "text" : "password"}
          className="form-input cp-input"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          aria-describedby={idReglas}
          aria-invalid={invalido || undefined}
        />
        <button
          type="button"
          className="cp-ojo"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
          aria-pressed={visible}
          aria-controls={id}
          title={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        >
          {visible ? <IconoOjoTachado /> : <IconoOjo />}
        </button>
      </div>

      {mostrarReglas && (
        <ul className="cp-reglas" id={idReglas}>
          {REGLAS_PASSWORD.map((r) => {
            const ok = r.cumple(value || "");
            return (
              <li key={r.id} className={ok ? "ok" : ""}>
                <span aria-hidden="true">{ok ? "✓" : "•"}</span> {r.texto}
                <span className="cp-sr">{ok ? " (cumplido)" : " (pendiente)"}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
